import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { WatchlistData, WatchlistItem } from './watchlist.entity';

@Injectable({ providedIn: 'root' })
export class WatchlistInfrastructure {
  private readonly endpoint = `${environment.apihost}/api/wl`;

  constructor(private _http: HttpClient) {}

  public getWatchlist(): Observable<WatchlistData[]> {
    return this._http.get<WatchlistData[]>(this.endpoint);
  }

  public postWatchlistItem(isin: string): Observable<WatchlistData> {
    return this._http.post<WatchlistData>(`${this.endpoint}/${isin}`, {});
  }

  public deleteWatchlistItem(isin: string): Observable<void> {
    return this._http.delete<void>(`${this.endpoint}/${isin}`);
  }

  public putWatchlistItem(item: WatchlistItem): Observable<void> {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars, unused-imports/no-unused-vars
    const { cachedHistoricQuote, newestHistoricQuote, ...watchlistItem } = item;
    const { isin } = watchlistItem;
    return this._http.put<void>(`${this.endpoint}/${isin}`, watchlistItem);
  }

  public putWatchlist(items: WatchlistItem[]): Observable<WatchlistData[]> {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars, unused-imports/no-unused-vars
    const watchlistItems = items.map(({ cachedHistoricQuote, newestHistoricQuote, ...watchlistItem }) => watchlistItem);
    return this._http.put<WatchlistData[]>(this.endpoint, watchlistItems);
  }
}
